var $ = require('jquery');
var Cookie = require('./cookie');

var PromoBar = function() {};

PromoBar.prototype = {

    init: function(options, el) {
        this.$el = $(el);

        // Prepare options
        this.options = options;
        this.options.endpoint = this.$el.data('promoBarEndpoint') || null;
        this.options.cookieName = this.$el.data('promoBarName') || '';

        // Setup static or async promo-bar
        if (this.options.endpoint) {
            this.setupAsyncPromoBar();
        } else {
            this.setupStaticPromoBar();
        }
    },

    setupAsyncPromoBar: function() {
        this.getMessage();
    },

    setupStaticPromoBar: function() {
        this.attachEvents();
    },

    getMessage: function(){
        $.getJSON(this.options.endpoint, this.processMessageResponse.bind(this));
    },

    processMessageResponse: function(data) {
        if (data.name != null) {
            this.options.cookieName = data.name;
            this.$el.attr('data-promo-bar-name', data.name);
            this.$el.html(data.content);
            this.attachEvents();
            this.show();
        }
    },

    attachEvents: function(){
        this.$el.find(this.options.dismissSelector).on('click', function(e) {
            e.preventDefault();
            this.hide();
            this.setSeenCookie();
        }.bind(this));
    },

    show: function(){
        this.$el.removeAttr('data-hidden');
        if (typeof(this.options.onShow) == 'function') {
            this.options.onShow(this);
        }
        $(document).trigger('promo-bar-show');
    },

    hide: function(){
        this.$el.attr('data-hidden', '');
        if (typeof(this.options.onHide) == 'function') {
            this.options.onHide(this);
        }
        $(document).trigger('promo-bar-hide');
    },

    setSeenCookie: function(fast){
        Cookie.set(this.options.cookieName, 1, this.options.cookieDays);
    }

};

module.exports = PromoBar;



// WEBPACK FOOTER //
// ./~/@99designs/asimov-promo-bar/lib/promo-bar-lib.js